<template>
  <RiskmaLine
    v-if="chartData.datasets && chartData.datasets.length > 0"
    :options="chartOptions"
    :data="chartData"
    :height="$vuetify.breakpoint.lgAndUp ? '170px' : '200px'"
  />
</template>

<script>
import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement,
} from "chart.js";
import axios from "axios";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  LineElement,
  PointElement
);
const COLORS = [
  {
    name: "1/10",
    level: "L10",
    code: "#238100",
  },
  {
    name: "1/30",
    level: "L30",
    code: "#FEFF54",
  },
  {
    name: "1/50",
    level: "L50",
    code: "#FF8038",
  },
  {
    name: "1/100",
    level: "L100",
    code: "#ff1300",
  },
  {
    name: "1/150",
    level: "L150",
    code: "#f027ff",
  },
  {
    name: "1/200",
    level: "L200",
    code: "#880088",
  },
  {
    name: "想定最大規模",
    level: "LMAX",
    code: "#000000",
  },
];

import moment from "moment";

export default {
  name: "LineChart",
  components: { RiskmaLine: Line },
  props: ["river"],
  data() {
    return {
      chartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        layout: {
          padding: {
            left: 44,
            top: -20,
          },
        },
        animation: false,
        responsive: true,
        scales: {
          x: {
            display: true,
            max: 1000,
          },
          y: {
            display: true,
          },
        },
        plugins: {
          title: {
            display: true,
            text: "",
          },
          legend: {
            display: false,
          },
          tooltip: {
            callbacks: {
              label: function (context) {
                return context.formattedValue + "mm";
              },
            },
          },
          annotation: {
            annotations: {},
          },
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchData();
    });
  },
  methods: {
    getLatestUrl(hourOffset = 0) {
      const now = moment();
      const utcNow = now.utc().subtract(hourOffset, "hours");

      const validHours = [0, 6, 12, 18];
      const currentHour = utcNow.hour();
      const latestValidHour = validHours.reduce((prev, curr) =>
        curr <= currentHour ? curr : prev
      );

      let fileDate = utcNow.clone();
      if (currentHour < latestValidHour) {
        fileDate.subtract(1, "days");
      }

      const YYYYMMDD = fileDate.format("YYYYMMDD");
      const HHMM = moment({ hour: latestValidHour }).format("HH") + "00";

      return `https://s3.ap-northeast-1.amazonaws.com/ctie.realtime.basin.ensemble/forecast_each3hr/${YYYYMMDD}/${YYYYMMDD}${HHMM}_${this.river.id}.json`;
    },
    async fetchData() {
      const datasets = [];
      const labels = [];
      let hourOffset = 0;

      while (hourOffset <= 24) {
        const url = this.getLatestUrl(hourOffset);

        try {
          const response = await axios.get(url);
          const detail = response.data;

          for (let key in detail) {
            datasets.push({
              data: detail[key],
              backgroundColor: "rgba(75, 192, 192, 0.3)",
              borderColor: "rgba(75, 192, 192)",
              borderWidth: 0.5,
            });
          }

          for (let i = 0; i < 39; i += 3) {
            labels.push("+" + (i + 3) + "h");
          }

          this.chartData.datasets = datasets;
          this.chartData.labels = labels;
          this.chartOptions.scales.y.max =
            parseInt(this.river.LMAX / 100) * 100 + 100;

          COLORS.forEach((color, index) => {
            this.chartOptions.plugins.annotation.annotations[
              "box" + (index + 1)
            ] = {
              type: "line",
              borderColor: color.code,
              borderWidth: 1.2,
              scaleID: "y",
              value: this.river[color.level],
              label: {
                display: false,
                drawTime: "afterDatasetsDraw",
                content: () => [
                  `${color.name} : ${this.river[color.level]} mm`,
                ],
              },
              enter({ element }) {
                element.label.options.display = true;
                return true;
              },
              leave({ element }) {
                element.label.options.display = false;
                return true;
              },
            };
          });

          return;
        } catch (e) {
          console.warn(`Failed to fetch data from ${url}. Retrying...`);
          hourOffset += 6;
        }
      }

      console.error(
        "No valid data available for the past 24 hours. Please check the data source."
      );
    },
  },
};
</script>
